import { BasicFrame } from 'components/organisms';
import { FormViewTemplate } from 'types';
import { Loading } from 'components/molecules';
import React from 'react';
import styles from './RequestLoading.module.scss';

export interface RequestLoadingTemplateProps {
  content: {
    title: string;
    subtitle: string;
  };
}

const RequestLoadingTemplate: FormViewTemplate<RequestLoadingTemplateProps> = (
  props,
) => (
  <BasicFrame {...props}>
    <div className={styles['container']}>
      <Loading text={props.content.subtitle} title={props.content.title} />
    </div>
  </BasicFrame>
);

export default RequestLoadingTemplate;
